import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import { AboutRoutes } from "../routes/AboutRoutes";
import { AcademicsRoutes } from "./AcademicsRoutes";
import { AdmissionsRoutes } from "./AdmissionsRoutes";
import { PlacementRoutes } from "./PlacementRoutes";
import { LifeAtCampusRoutes } from "./LifeAtCampusRoutes";
import { ExaminationsRoutes } from "./ExaminationsRoutes";
import ContactUs from "../page_content/contact_us/ContactUs";
import { AlumniRoutes } from "./AlumniRoutes";



const MainRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {AboutRoutes}
      {AcademicsRoutes}
      {AdmissionsRoutes}
      {PlacementRoutes}
      {LifeAtCampusRoutes}
      {ExaminationsRoutes}
      {AlumniRoutes}
      <Route path="contact" element={<ContactUs />} />
    </Routes>
  );
};

export default MainRoutes;
